/*
 * Ottoline — free trade samples cap.
 *
 * Approved trade customers (customer tag `free-samples`) get a fixed number of
 * sample units free, in any combination. The allowance is published by
 * layout/theme.liquid as window.OttolineSampleCap.limit; it is 0 for everyone
 * else, which switches this file off entirely — retail customers pay for
 * samples and may buy as many as they like.
 *
 * product-form.js blocks an add-to-cart that would take a trade customer past
 * the allowance. This file is the safety net behind it: it catches the routes
 * that don't go through the product form — editing quantities on the cart page,
 * /cart/add permalinks, a stale cart restored in another tab — and trims the
 * cart back to the allowance.
 */
(function () {
  var config = window.OttolineSampleCap || {};
  var LIMIT = parseInt(config.limit, 10) || 0;
  if (LIMIT <= 0) return;

  var NOTICE_ID = 'OttolineSampleCapNotice';
  var checking = false;

  function isSample(item) {
    var title = (item.variant_title || '') + ' ' + (item.title || '');
    return /(^|[^a-z])samples?([^a-z]|$)/i.test(title);
  }

  function sampleUnits(items) {
    return items.reduce(function (total, item) {
      return isSample(item) ? total + item.quantity : total;
    }, 0);
  }

  function showNotice(removed) {
    if (document.getElementById(NOTICE_ID)) return;
    var notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.setAttribute('role', 'status');
    notice.style.cssText =
      'position:fixed;left:50%;transform:translateX(-50%);bottom:2rem;z-index:100;' +
      'max-width:38rem;padding:1.2rem 1.6rem;border-radius:0.4rem;text-align:center;' +
      'background:#aabab9;color:#fefaf0;font-size:1.4rem;line-height:1.5;' +
      'box-shadow:0 0.2rem 1.2rem rgba(0,0,0,0.18);';
    notice.textContent =
      'Trade accounts include ' +
      LIMIT +
      ' free samples per order, in any combination. We’ve removed ' +
      removed +
      ' sample' +
      (removed === 1 ? '' : 's') +
      ' to bring your basket back to ' +
      LIMIT +
      '.';
    document.body.appendChild(notice);
    setTimeout(function () {
      if (notice.parentNode) notice.parentNode.removeChild(notice);
    }, 9000);
  }

  // Trim from the last sample line backwards, one /cart/change call at a time.
  function trim(items, excess) {
    for (var i = items.length - 1; i >= 0; i--) {
      var item = items[i];
      if (!isSample(item)) continue;

      var keep = Math.max(0, item.quantity - excess);
      var removedHere = item.quantity - keep;

      return fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({line: i + 1, quantity: keep}),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var remaining = excess - removedHere;
          if (remaining > 0) return trim(cart.items, remaining);
          return cart;
        });
    }
    return Promise.resolve(null);
  }

  function enforce() {
    if (checking) return Promise.resolve();
    checking = true;

    return fetch((window.routes && window.routes.cart_url) || '/cart', {
      headers: {Accept: 'application/json'},
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var excess = sampleUnits(cart.items || []) - LIMIT;
        if (excess <= 0) return null;
        return trim(cart.items, excess).then(function (updated) {
          showNotice(excess);
          return updated;
        });
      })
      .then(function (updated) {
        if (updated) {
          // The cart sections on screen are now stale — a reload is the only
          // reliable way to resync every theme surface (page, drawer, notification).
          setTimeout(function () {
            window.location.reload();
          }, 2500);
        }
      })
      .catch(function (error) {
        console.error('[ottoline-sample-cap]', error);
      })
      .finally(function () {
        checking = false;
      });
  }

  // Re-check whenever the cart changes, however it changed.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var touchesCart = /\/cart\/(add|change|update)/.test(url);
    var result = nativeFetch.apply(this, arguments);
    if (touchesCart) {
      result.then(function () {
        setTimeout(enforce, 250);
      });
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }
})();
